import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  title: {
    margin: 0,
    fontSize: 21,
    fontWeight: 400,
    color: '#444',
  },
  tag: {
    marginLeft: 15,
    padding: '5px 10px',
    fontSize: 11,
    fontWeight: 400,
    background: '#42464d',
    borderRadius: 2,
    color: '#fff',
    textTransform: 'uppercase',
  },
}));
